import moment from "moment";
import React from "react";
import { Controller, useFormState } from "react-hook-form";

/**
 * Form controls used only on the online-booking registration step.
 * Keeps boolean checkboxes and text fields aligned with Yup without changing
 * legacy `InputField` (multi-checkbox + customOnChange patterns).
 */
interface SignupControlledFieldProps {
  name: string;
  type: "checkbox" | "email" | "text";
  control: any;
  errors?: object | any;
  id?: string;
  placeholder?: string;
  className?: string;
  hideErrorMessage?: boolean;
  submitAttempted?: boolean;
}

export default function SignupControlledField(props: SignupControlledFieldProps) {
  const {
    name,
    type,
    control,
    errors,
    hideErrorMessage,
    id,
    placeholder,
    className,
    submitAttempted,
  } = props;

  const { touchedFields } = useFormState({ control });
  const fieldTouched = Boolean(
    (touchedFields as Record<string, boolean>)?.[name]
  );
  const shouldShowError =
    !hideErrorMessage &&
    errors &&
    (errors as Record<string, { message?: string }>)?.[name] &&
    (fieldTouched || submitAttempted);

  const currentDate = moment().format("YYYY-MM-DD");

  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => {
        if (type === "checkbox") {
          return (
            <>
              <input
                ref={field.ref}
                name={name}
                type="checkbox"
                onBlur={field.onBlur}
                onChange={(e) => field.onChange(e.target.checked)}
                id={id}
                checked={Boolean(field.value)}
              />
              {shouldShowError && (
                <span className="text-danger">
                  {(errors as Record<string, { message?: string }>)[name]
                    ?.message}
                </span>
              )}
            </>
          );
        }

        return (
          <>
            <input
              className={className}
              id={id}
              onBlur={field.onBlur}
              onChange={(e) => field.onChange(e.target.value)}
              type={type}
              ref={field.ref}
              placeholder={placeholder}
              value={field.value || ""}
              max={type === "date" ? currentDate : ""}
            />
            {shouldShowError && (
              <span className="text-danger">
                {(errors as Record<string, { message?: string }>)[name]?.message}
              </span>
            )}
          </>
        );
      }}
    />
  );
}
